import { NavLink } from "react-router-dom";

// نظام تبويبات موحّد: شرائح ملوّنة بحركة لطيفة — يُستخدم في كل الأقسام.
export const TONES = {
  sky: "text-sky-500 bg-sky-500/12",
  emerald: "text-emerald-500 bg-emerald-500/12",
  amber: "text-amber-500 bg-amber-500/12",
  violet: "text-violet-500 bg-violet-500/12",
  rose: "text-rose-500 bg-rose-500/12",
  teal: "text-teal-500 bg-teal-500/12",
  indigo: "text-indigo-500 bg-indigo-500/12",
  lime: "text-lime-500 bg-lime-500/12",
  orange: "text-orange-500 bg-orange-500/12",
  cyan: "text-cyan-500 bg-cyan-500/12",
};
const ORDER = Object.keys(TONES);

export const ModuleTabs = ({ tabs, testid = "module-tabs", wrap = false }) => (
  <div className={wrap ? "-mx-1 pb-1" : "-mx-1 overflow-x-auto pb-1"} data-testid={testid}>
    <div className={`flex items-center gap-2 px-1 py-1 ${
      wrap ? "flex-nowrap overflow-x-auto sm:flex-wrap sm:overflow-visible" : "min-w-max"
    }`}>
      {tabs.map(({ to, key, label, icon: Icon, end, tone }, index) => (
        <NavLink
          key={key}
          to={to}
          end={end}
          data-testid={`${testid}-${key}`}
          style={{ animationDelay: `${index * 45}ms` }}
          className={({ isActive }) =>
            `tab-chip flex shrink-0 items-center gap-2 whitespace-nowrap rounded-2xl px-4 py-2.5 text-xs font-bold transition-all duration-300 hover:-translate-y-0.5 ${
              isActive
                ? `${TONES[tone || ORDER[index % ORDER.length]]} shadow-neu-in scale-[1.02]`
                : "text-muted-foreground shadow-neu-sm hover:text-foreground"
            }`
          }
        >
          {Icon ? <Icon className="h-4 w-4" /> : null}
          {label}
        </NavLink>
      ))}
    </div>
  </div>
);
